module.exports = __webpack_public_path__ + "static/media/banco_bogota.1e08a909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/banco_bogota.png
// module id = 1993
// module chunks = 0